import { render, staticRenderFns } from "./zjfx.vue?vue&type=template&id=352058cc&scoped=true&"
import script from "./zjfx.vue?vue&type=script&lang=js&"
export * from "./zjfx.vue?vue&type=script&lang=js&"
import style0 from "./zjfx.vue?vue&type=style&index=0&id=352058cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352058cc",
  null
  
)

export default component.exports